import './bootstrap'
import './custom';
import 'select2/dist/js/select2.full'

import Vue from 'vue'
Vue.use(require('vue-moment')) 

import VueSwal from 'vue-swal'
Vue.use(VueSwal)

import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

import store from './store'

import BookingPage from './views/BookingPage'
import SchedulePage from './views/SchedulePage'
import BookingSearch from './views/BookingSearch'
import BookingSearchDaytrip from './views/BookingSearchDaytrip'
import BookingWidget from './views/BookingWidget'
import ContactForm from './views/ContactForm'
import GroupRequestForm from './views/GroupRequestForm'

Vue.component('booking-page', BookingPage)
Vue.component('schedule-page', SchedulePage)
Vue.component('booking-search', BookingSearch)
Vue.component('booking-search-daytrip', BookingSearchDaytrip)
Vue.component('booking-widget', BookingWidget)
Vue.component('contact-form', ContactForm)
Vue.component('group-request-form', GroupRequestForm)

import $api from './services/api'

window.dataLayer = window.dataLayer || []

const app = document.getElementById('app')
if (app) {
    store.commit('setPorts', Object.values(window.venezialines.ports))

    Vue.mixin({
        computed: {
            $api: () => $api,
        },
        methods: {
            currency(value) {
                return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR' }).format(value);
            },
            track(data) {
                if (process.env.NODE_ENV == 'production') {
                    window.dataLayer?.push(data)
                } else {
                    console.log(data)
                }
            }
        }
    });

    new Vue({
        el: app,
        store,
    })
}
